import httpClient from "../http/http-client";
import { IFileUploadSetting, IPostFileUploadSetting } from './file-upload-setting.model';

export default class FileUploadSettingService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<IFileUploadSetting[]> {
    return this.http.get(`file-upload-setting${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(fileUploadSettingId: string, fileUploadSetting: IPostFileUploadSetting): Promise<IFileUploadSetting> {
    return this.http.patch(`file-upload-setting/${fileUploadSettingId}`, fileUploadSetting)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}